import type { SbBlokData } from "@storyblok/js";
import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import {
	MARK_BOLD,
	MARK_ITALIC,
	NODE_HEADING,
	NODE_LI,
	NODE_OL,
	NODE_PARAGRAPH,
	NODE_UL,
	render,
} from "storyblok-rich-text-react-renderer";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import { BodyHeading } from "~/components/bloks/RichTextBlok/resolvedBloks/BodyHeading";
import { Italic } from "~/components/bloks/RichTextBlok/resolvedBloks/Italic";
import { ListItem } from "~/components/bloks/RichTextBlok/resolvedBloks/ListItem";
import type { RichTextStoryblok } from "~/generated/sb/blok-types";
import styles from "./RichTextBlok.module.css";

export const RichTextBlok = ({
	blok,
	firstElement,
}: BlokProps<RichTextStoryblok> & { firstElement?: boolean }) => {
	const { body } = blok;

	const renderOptions: {
		markResolvers: Record<string, (children: React.JSX.Element) => React.JSX.Element>;
		blokResolvers: Record<string, (blok: SbBlokData) => React.JSX.Element>;
		nodeResolvers: Record<string, (children: any, level: any) => React.JSX.Element>;
	} = {
		markResolvers: {
			[MARK_BOLD]: (children) => <strong>{children}</strong>,
			[MARK_ITALIC]: (children) => <Italic>{children}</Italic>,
		},
		blokResolvers: {
			button: (blok: any) => (<button type="button">{blok}</button>) as React.JSX.Element,

			// ["title"]: (blok) => <StoryblokComponent blok={blok} />,
			// ["media"]: (blok) => <StoryblokComponent blok={blok} />,
			// ["mediaGallery"]: (blok) => <StoryblokComponent blok={blok} />,
			// ["link"]: (blok) => (
			//   <StoryblokLink
			//     blok={blok as StoryblokLinkBlok}
			//     className={`${styles.link}`}
			//   />
			// ),
			// ["space"]: () => <div className={`${styles.space}`} />,
		},
		nodeResolvers: {
			[NODE_HEADING]: (children, level) => (
				<BodyHeading level={level.level}>{children}</BodyHeading>
			),
			[NODE_PARAGRAPH]: (children) => <p>{children}</p>,
			[NODE_UL]: (children) => <ul className={styles.unordered__list}>{children}</ul>,
			[NODE_OL]: (children) => <ol className={styles.ordered__list}>{children}</ol>,
			[NODE_LI]: (children) => <ListItem>{children}</ListItem>,
		},
	};
	const alignmentMap = {
		left: styles.align__left,
		right: styles.align__right,
		center: styles.align__center,
		full: styles.align__full,
	};
	const alignmentClass = alignmentMap[blok?.align || "left"];
	return (
		<BlokWrap
			editable={blok}
			data-alignment={blok.align}
			className={clsx(styles.container, "rich-text-blok", alignmentClass)}
			data-blok
			data-first-element={firstElement}
		>
			{render(body, renderOptions as any)}
		</BlokWrap>
	);
};
